import React from 'react'
import Box from '@mui/material/Box';
import Skeleton from '@mui/material/Skeleton';

const MenuLoadingSkeleton = ({ variant, marginy, marginx, count, height }) => {
    return (
        <Box sx={{ height: "max-content" }} >
            {[...Array(count ? count : 1)].map((index, value) => (
                <Skeleton
                    key={`menu-skeleton-item-${value}`}
                    variant={variant} sx={{ my: marginy ? marginy : null, mx: marginx ? marginx : null }} height={height ? height : null} />
            ))}
        </Box>
    )
}

export default MenuLoadingSkeleton